export default __webpack_public_path__ + "static/media/dotPattern2.cd0ac12f.svg";